import { render, staticRenderFns } from "./PaidInvestmentRequests.vue?vue&type=template&id=7b9ae88d&"
import script from "./PaidInvestmentRequests.vue?vue&type=script&lang=js&"
export * from "./PaidInvestmentRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports